import type { Mode } from '@hewey/shared'
import { Toggle } from '@components/Toggle.tsx'
import { useMode } from './ModeContext.tsx'

const OPTIONS: ReadonlyArray<{ value: Mode; label: string }> = [
	{ value: 'personal', label: 'Personal' },
	{ value: 'family', label: 'Family' },
]

export const ModeToggle = () => {
	const { mode, setMode } = useMode()

	return (
		<Toggle
			ariaLabel="Personal or family"
			options={OPTIONS.map((opt) => ({
				key: opt.value,
				label: opt.label,
				active: mode === opt.value,
				onSelect: () => setMode(opt.value),
			}))}
		/>
	)
}
